// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2bsLG","image":"Header_image__1SF49","name":"Header_name__2-yWu","info":"Header_info__ZjgDL","infoRow":"Header_infoRow__u_vmU"};